import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { GlobalNotificationComponent } from './global-notification.component';
import { DaButtonModule } from '../da-button/da-button.module';
import { DaLinkModule } from '../da-link/da-link.module';
import { CookieService } from 'ngx-cookie-service';

@NgModule({
    declarations: [GlobalNotificationComponent],
    imports: [CommonModule, DaButtonModule, DaLinkModule, RouterModule, LocalizeRouterModule],
    exports: [GlobalNotificationComponent],
    providers: [CookieService]
})
export class GlobalNotificationModule {}
